import { Children, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

export default class VisibilitySensor extends PureComponent {
    static defaultProps = {
        onChange: noop,
        onLeave: noop,
        onEnter: noop,
        once: false,
        options: null,
    };

    static propTypes = {
        onChange: PropTypes.func.isRequired,
        onLeave: PropTypes.func.isRequired,
        onEnter: PropTypes.func.isRequired,
        once: PropTypes.bool.isRequired,
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
        /** @type {IntersectionObserverInit} */
        options: PropTypes.object,
    };

    componentDidMount() {
        this.root = ReactDOM.findDOMNode(this); // eslint-disable-line
        this.observer = new IntersectionObserver(this.checkIntersection, this.props.options);
        this.observer.observe(this.root);
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    _isVisible = false;

    checkIntersection = (entries) => {
        const isIntersecting = entries.every(e => e.intersectionRatio > 0 || e.isIntersecting);

        if (isIntersecting === this._isVisible) {
            return;
        }

        this.props[isIntersecting ? 'onEnter' : 'onLeave']();
        this._isVisible = isIntersecting;
        this.props.onChange(isIntersecting);

        if (this.props.once && this._isVisible) {
            this.observer.unobserve(this.root);
        }
    };


    render() {
        return Children.only(this.props.children);
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/visibility-sensor/index.js